module.exports = __webpack_public_path__ + "img/系统优势.9a08f300.png";